import React, {useEffect, useState} from "react";
import {
    Card,
    CardContent,
    InputLabel,
    Avatar,
    Typography,
    CardHeader,
    Select,
    MenuItem,
    FormControl,
    TextField,
  } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {agentStatuses } from "./constants.js";
import QuestionMarkIcon from "@material-ui/icons/HelpOutline";

const useStyles = makeStyles((theme) => ({
  
    fontColor:{
      color:'white',
    
    },

    formControl: {
        width:"250px",
        //padding:theme.spacing(1),
        marginLeft: theme.spacing(2),
        "& .MuiSelect-icon":{
          color:'white',
      },

    },
  }));


  var outComes=null;
  var primaryOutComeTitle = null;
  var secondaryOutComeTitle = null;
  let callOutCome,setCallOutCome;
  let initOutCome = {primaryOutCome:'',secondaryOutCome:''};
  export default function SetOutComes(props) {
    const classes = useStyles();
    [callOutCome, setCallOutCome] = useState(initOutCome);
    
    outComes = [...props.outComeData.SettingsACD.PrimaryOutComes];
    primaryOutComeTitle = props.outComeData.SettingsACD.PrimaryOutcomeTitle;
    secondaryOutComeTitle  = props.outComeData.SettingsACD.SecondaryOutcomeTitle;
    //console.log(props.callOutCome.enable);
    //window.outComes = outComes;
    const handlePrimaryChange = (event) => {
       //props.updateOutCome({...props.callOutCome,PrimaryOutCome:event.target.value});
      setCallOutCome({...callOutCome, primaryOutCome:event.target.value});
       // getSecondaryOutComes();
    };
    const handleSecondaryChange = (event) => {
        //props.updateOutCome({...props.callOutCome,SecondaryOutCome:event.target.value});
        setCallOutCome({...callOutCome, secondaryOutCome:event.target.value});
     };

     useEffect(() => {
        // console.log("SETOUTCOMES USE EFFECT");
        props.onChange(callOutCome);

     },[callOutCome]);
    const getSecondaryOutComes = () =>{
        if(outComes[0].Title != '' && callOutCome.primaryOutCome != ''){
        const soc = outComes.filter(({Title})=> Title===callOutCome.primaryOutCome)[0].SecondaryOutComes;
  
            return(
                soc.map(({Title}) => (
               <MenuItem value={Title}>{Title}</MenuItem>))
               )
        }
        
    };


    return(
        <Card raised="true" style={{backgroundColor:'#1b1c1c', minHeight:'120px'}}>
            <CardHeader 
            avatar = {<Avatar>
            <QuestionMarkIcon style={{fontSize:"50px", color:'#979a96'}}/>
            </Avatar>
            }
             title={<><div>
          <FormControl className={classes.formControl}>
          <TextField
          inputProps={{className:classes.fontColor}}
          color="primary"
          id="selectprimaryreason"
          select
          label={<Typography style={{color:'white'}}>{primaryOutComeTitle}</Typography>}
          value={callOutCome.primaryOutCome}
          onChange={handlePrimaryChange}
        >
          {outComes.map(({Title}) => (
                    <MenuItem value={Title}>{Title}</MenuItem>
                ))}
        </TextField>
        </FormControl>
        </div>
        <div>
        <FormControl className={classes.formControl}>
        <TextField
        inputProps={{className:classes.fontColor}}
          id="selectsecondaryreason"
          select
          label={<Typography style={{color:'white'}}>{secondaryOutComeTitle}</Typography>}
          value={callOutCome.secondaryOutCome}
          onChange={handleSecondaryChange}
        >
          {getSecondaryOutComes()}
        </TextField>
        </FormControl>
        </div></>
             }
             />
      </Card>
    );
  }